import { z } from 'zod';
import { Event, EventSchema } from '@/types/events';
import { INITIAL_EVENT_DATA } from '../hooks/useEvents';
import { calculateBudgetMetrics } from './metrics';
import { v4 as uuidv4 } from 'uuid';

export const validateEvent = (eventData: Partial<Event>): Event => {
  try {
    const eventToValidate = {
      ...INITIAL_EVENT_DATA,
      ...eventData,
      id: eventData.id || uuidv4(),
      createdAt: eventData.createdAt || new Date().toISOString(), 
      updatedAt: new Date().toISOString(),
      // Ensure required arrays exist
      objectives: eventData.objectives || [],
      targetGrades: eventData.targetGrades || [],
      eventResources: eventData.eventResources || [],
      staffAssignments: eventData.staffAssignments || [],
      occurrences: eventData.occurrences || [],
      budget: eventData.budget || [],
      tasks: eventData.tasks || [],
      resources: eventData.resources || [],
      feedback: eventData.feedback || [],
      compliance: eventData.compliance || [],
      metrics: {
        attendance: 0,
        satisfaction: 0,
        budget: calculateBudgetMetrics({
          ...INITIAL_EVENT_DATA,
          ...eventData
        })
      }
    };

    const result = EventSchema.safeParse(eventToValidate);
    
    if (!result.success) {
      const errorMessages = result.error.errors.map(err => {
        const path = err.path.join('.');
        return `${path || 'Event'}: ${err.message}`;
      }).join(', ');
      throw new Error(`Event validation failed: ${errorMessages}`);
    }
    
    return result.data;
  } catch (err) {
    if (err instanceof z.ZodError) {
      const errorMessages = err.errors.map(e => {
        const path = e.path.join('.');
        return `${path || 'Event'}: ${e.message}`;
      }).join(', ');
      throw new Error(`Event validation failed: ${errorMessages}`);
    }
    throw err;
  }
};